window.HChart = function (idOrElement, nunjucksEnv, options) {

    var self = this;

    options = options || {};

    var id = typeof(idOrElement) == 'string'? idOrElement: 'id_' + Date.now();
    var element = typeof(idOrElement) == 'string'? $('#' + idOrElement): idOrElement;

    var chart;

    var defaultSize = {
        height: 320,
        width: 920
    };

    var chartId;
    const colors = ['var(--h-alert-400)', 'var(--h-primary)', '#551A8B', '#fe8523'];


    var defaultOptions = {
        bindto: element,
        data: {
            columns: [],
            colors: {},
            types: {}
        },
        legend: {
            show: false,
            position: 'inset',
            inset: {
                anchor: 'top-right',
                x: 120,
                y: 30
            }
        },
        axis: {
            x: {
                type: HChart.X_AXIS_TYPES.TIME_SERIES,
                tick: {
                    culling: false,
                    format: '%Y-%m-%d %H:%M:%S'
                }
            },
            y: {
                show: true,
                tick: {}
            }
        },
        grid: {
            x: {
                show: true
            },
            y: {
                show: true
            }
        },
        point: {
            r: 5,
            select: {
                r: 20
            },
            focus: {
                expand: {
                    r: 6
                }
            }
        },
        tooltip: {
            show: true,
	        format: {}
        },
        zoom: {
            enabled: true
        },
        bar: {
            width: {
                ratio: 0.5
            }
        },
	    pie: {
		    label: {
			    show: false
		    }
	    },
        donut:{
            width: 90,
            label: {
                show: false
            },
            title: '',
        },
        gauge: {
            fullCircle: true,
            startingAngle: ((3.14/2) *3),
            label: {
                format: function(value, ratio) {
                    return value + " %";
                },
                show: false // to turn off the min/max labels.
            },
            min: 0, // 0 is default, //can handle negative min e.g. vacuum / voltage / current flow / rate of change
            max: 100, // 100 is default
            width: 35 // for adjusting arc thickness
        }
    };

    angular.extend(defaultOptions, options);

    /**
     *
     * [
     *  Generate the legend for chart header so the user can show hide what he want,
     *  this drawing tools in d3js not in c3js
     * ]
     */

    var renderLegend = function(chartOptions){

        var $$ = chart.internal;
        var customLegend = chartOptions.legend || {};

        $('.h-chart-box').css('opacity','0');
        var config = {
            legend_data: [],
            legend_css_class: 'h-legend',
            legend_item_css_class: 'legend-item',
            legend_position:  'inset',
            legend_inset_anchor: 'top-right',
            legend_inset_x: 120,
            legend_inset_y: 30 ,
            legend_inset_y_direction: 'top',
            legend_inset_x_direction: 'left',
            legend_item_clickable: true,
            legend_item_onclick: undefined,
            legend_item_onmouseover: undefined,
            legend_item_onmouseout: undefined,
        };

        config.legend_position =  customLegend.position || config.legend_position;

        if(customLegend.inset && customLegend.inset.anchor){
            config.legend_inset_anchor = customLegend.inset.anchor;
        }

        if(customLegend.inset && customLegend.inset.x){
            config.legend_inset_x = customLegend.inset.x;
        }

        if(customLegend.inset && customLegend.inset.y){
            config.legend_inset_y = customLegend.inset.y;
        }


        if(config.legend_position === 'inset'){

            config.legend_css_class = config.legend_css_class + ' inset';

            if(customLegend.inset && customLegend.inset.anchor){
                config.legend_inset_anchor = customLegend.inset.anchor;
            }

            if(customLegend.inset && customLegend.inset.x){
                config.legend_inset_x = customLegend.inset.x;
            }

            if(customLegend.inset && customLegend.inset.y){
                config.legend_inset_y = customLegend.inset.y;
            }

            var directions = config.legend_inset_anchor.split("-");
            config.legend_inset_x_direction = directions[1];
            config.legend_inset_y_direction = directions[0];

            if((config.legend_inset_y_direction !== 'top' && config.legend_inset_y_direction !== 'bottom') || (config.legend_inset_x_direction !== 'left' && config.legend_inset_x_direction !== 'right')){
                console.error('[legend inset position] ('+config.legend_inset_anchor+') not valid value for anchor, available values : \n top-left \n top-right \n bottom-left \n bottom-right');
                return;
            }

        }

        if(customLegend.item && customLegend.item.hasOwnProperty('clickable')){
            config.legend_item_clickable = customLegend.item.clickable;
        }

        if(config.legend_item_clickable){
            config.legend_item_css_class = config.legend_item_css_class + ' clickable';
        }

        if(customLegend.item && customLegend.item.onclick && customLegend.item.onclick instanceof Function ){
            config.legend_item_onclick = customLegend.item.onclick;
        }

        if(customLegend.item && customLegend.item.onmouseover && customLegend.item.onmouseover instanceof Function ){
            config.legend_item_onmouseover = customLegend.item.onmouseover;
        }

        if(customLegend.item && customLegend.item.onmouseout && customLegend.item.onmouseout instanceof Function ){
            config.legend_item_onmouseout = customLegend.item.onmouseout;
        }


        if(customLegend.data){
            if(!Array.isArray(customLegend.data)){
                console.error("The legend data should be array of objects : [{id: '..', lable: '..'}, ..]");
                return;
            }

            config.legend_data = customLegend.data;
        }else{

            var chartData = chart.data();
            chartData.forEach(function(item){
               var tmp = {};
               tmp.id = item.id_org;
               tmp.label = item.id_org;
                config.legend_data.push(tmp);
            });

        }

        for(var i = 0; i< config.legend_data.length; i++){

            var tmp = config.legend_data[i];
            if(!tmp.id || !tmp.label){
                console.error(tmp);
                console.error("Every item in legend data should have it's id and label {id: '..', lable: '..'} : ");
                return;
            }
            tmp.index = i;
            config.legend_data[i] = tmp;
        }

        const chartBoxElement = d3.select(`#${chartId}`).node().closest('.h-chart-box');
        const legend = d3.select(chartBoxElement)
            .insert('div')
            .attr('class', config.legend_css_class);

        if(config.legend_position === 'inset'){
            legend
                .style(config.legend_inset_y_direction, config.legend_inset_y+'px')
                .style(config.legend_inset_x_direction, config.legend_inset_x+'px')
        }
        legend
            .selectAll('div')
            .data(config.legend_data)
            .enter()
            .append('div')
            .attr('class', config.legend_item_css_class)
            .html(function (item) {
                var line = {};
                line['color'] = chart.color(item.id);
                line['id'] = item.id;
                line['label'] = item.label;
                return nunjucksEnv.render("../modules/chart/views/h-legend.html", line);
            })
            .on('mouseover', function (item) {

                if(config.legend_item_onmouseover){
                    config.legend_item_onmouseover(item);
                }else{
                    chart.focus(item.id);
                }
            })
            .on('mouseout', function (item) {

                if(config.legend_item_onmouseout){
                    config.legend_item_onmouseout(item);
                }else{
                    chart.revert();
                }
            })
            .on('click', function (item) {
                if(!config.legend_item_clickable){
                    return;
                }
                if(config.legend_item_onclick){
                    config.legend_item_onclick(item);
                }else{
                    chart.internal.isTargetToShow(item.id) ?  $(this).css('opacity','0.2') : $(this).css('opacity','1');
                    chart.toggle(item.id);
                }
            });




        setTimeout(function(){

            d3.select('.h-chart-box')
                .insert('div')
                .attr('class','clearfix');

            var chartElement = d3.select('.h-chart').node();
            if(chartElement){
                var chartElementDimensions = chartElement.getBoundingClientRect();

                var legendElement = d3.select('.h-legend').node();
                var legendElementDimensions = legendElement.getBoundingClientRect();

                if(config.legend_position === 'right') {

                    var legendElementWidth = legendElement.getBoundingClientRect().width + 10;
                    var width = 'calc(100% - ' + legendElementWidth + 'px)';
                    d3.select('.h-chart').style('width', width);

                }

                if(chartOptions.dataType == HChart.CHART_TYPES.DONUT){

                    var shapElement = d3.select('.c3-chart-arcs').node();
                    var shapElementDimensions = shapElement.getBoundingClientRect();


                    var left = (chartElementDimensions.width + shapElementDimensions.width) / 2 ;
                    d3.select('.h-legend').style('right','auto');
                    d3.select('.h-legend').style('left',left+16+'px');

                    var top = ((chartElementDimensions.height - legendElementDimensions.height)/ 2 ) + (chartElementDimensions.height - shapElementDimensions.height);
                    d3.select('.h-legend').style('bottom','auto');
                    d3.select('.h-legend').style('top',top +'px');
                }
                $$.updateSizes();
                $$.updateScales();
                $$.updateSvgSize();
                $$.transformAll(true);
                if(chartOptions.data?.columns[0]){
                    chart.zoom([0,chartOptions.data.columns[0].length-1]);
                    if(chartOptions.data.columns[0].length-1 > 9) {
                        setTimeout(function () {
                            chart.zoom([0, 9]);
                        }, 100)
                    }
                }
            }
        },0);

        setTimeout(function(){
            $('.h-chart-box').css('opacity',1);
        },100);

    }
    var appendLegend = function (lines) {

        element.find('.legend').html("");
        var dataColors = chart.data.colors();

        if (lines && lines.length>0) {
            lines.forEach(function(line){

                d3.select(element)
                    .select('.legend')
                    .data([line.key])
                    .append('span')
                    .html(function (id) {
                        line['color'] = line['color'] || dataColors[id];
                        line['id'] = id;
                        return nunjucksEnv.render("../modules/chart/views/legend.html", line);
                    })
                    .on('click', function (id) {

                        var clicked = $("#" + id + "-legend").hasClass("c3-legend-item-hidden");

                        if (!clicked) {
                            chart.revert();
                        }

                        $("#" + id + "-legend").toggleClass("c3-legend-item-hidden");
                        chart.toggle(id);
                    })
                    .on('mouseover', function (id) {

                        var clicked = $("#" + id + "-legend").hasClass("c3-legend-item-hidden");

                        if (!clicked) {
                            chart.focus(id);
                        }
                    })
                    .on('mouseout', function (id) {
                        chart.revert();
                    });
            });
        }

    };

    /**
     * [Change the chart range]
     * range: object
     *
     * {
     *  min: {
     *   x: -10,
     *   y: -1000,
     *   y2: -10000
     *  },
     *  max: {
     *    x: 100,
     *    y: 1000,
     *    y2: 10000
     *  },
     * }
     *
     *
     *
     * range: If not given the current range will return;
     */
    self.changeRange = function (range) {
        return (range)? chart.axis.range(range): chart.axis.range();
    };

    /**
     * [Change the type of the chart]
     * dataId: String
     * Specify the type to be transformed.
     * The types listed in data.type can be used.
     *
     * dataId: Array of strings
     * Specify targets to be transformed.
     *
     *
     *
     * dataId: If not given all targets will be the candidate.
     */
    self.changeType = function (type, dataId) {
        chart.transform(type, dataId);
    };

    /**
     * [If you need to force the chart to redraw it self]
     */
    self.refresh = function () {
        chart.flush();
    };

    /**
     * [force to resize the chart]
     */
    self.resizeChart = function (newSize) {
        newSize = newSize || defaultSize;

        chart.resize(newSize);
    };

    /**
     * [enable zooming the chart]
     */
    self.enableZoom = function () {
        chart.zoom.enable(true);
    };

    /**
     * [disable zooming in chart]
     */
    self.disableZoom = function () {
        chart.zoom.enable(false);
    };

  /**
   *
   * Workaround for bar chart category color, because its one data color
   *
   * ["cat 1", "cat 2", "cat 3"]
   * ["data", 10, 20, 30]
   *
   * c3js give one color per data not per x axis or category
   * so call this if you need custom color for bar category chart
   *
   * there is two type of bar chart category with one source or data
   * category for Time series or sequence data
   *
   * this workaround need for the first one.
   *
   */
    self.barChartColors = function (customColors) {

        d3.select(".reporting-charts")
          .selectAll(".c3-bar")
          .transition()
          .duration(0)
          .style("stroke", function (d) {
            return customColors[d.index];
          })
          .style("fill", function (d) {
            return customColors[d.index];
          })
          .style("opacity", 1);
    };


    /**
     *
     *  Set a callback which is executed when the chart is rendered.
     *  Basically, this callback will be called in each time when the chart is redraw again.
     *
     */
    self.onRendered = function (handler) {
        defaultOptions['onrendered'] = handler;
    };

    /**
     * [Load data to the chart]
     */
    self.render = function (data, type) {

        var chartData = angular.copy(data);
        var options = $.extend(true, {}, defaultOptions);
        options.data.order = chartData.order;
        if (chartData.dataType) {
            options.data.type = chartData.dataType;
            if (chartData.dataType == 'gauge') {
                options.data.columns.splice(0, 1);
                delete options.data.x;
            }
            if (chartData.dataType == HChart.CHART_TYPES.DONUT) {
                if (options.data.columns.length == 1 && options.data.columns[0][1] == 0) {
                    options.data.columns[0][1] = 1;
                }
            }
        }

        if (data.insetX !== undefined) {
            options.legend.inset.x = data.insetX;
        }

        if (data.legend && data.legend.item) {
            options.legend.item = data.legend.item;
        }

        if (data.x) {
            options.data.x = 'x';
            options.data.columns.push(["x"].concat(data.x));
        }
        if (data.data && data.data.columns) {
            options.data.columns = data.data.columns;
        }
        if (data.data && data.data.groups) {
            options.data.groups = data.data.groups;
        }
        if (data.grid) {
            options.grid = data.grid;
        }
        if (data.data && data.data.onClick) {
            options.data.onclick = data.data.onClick;
        }

        if (chartData && chartData.empty) {
            options.data.empty = chartData.empty;
        }

        for (var i in chartData.y) {
            var lineData = chartData.y[i].value;
            lineData.unshift(chartData.y[i].key);
            options.data.columns.push(lineData);
            options.data.colors[chartData.y[i].key] = chartData.y[i].color || colors[i % colors.length];
            options.data.types[chartData.y[i].key] = chartData.y[i].type || HChart.CHART_TYPES.SPLINE;
            options.data.axes = {...options.data.axes, ...chartData.y[i].axes};
        }

        for (var j in chartData.y2) {
            let lineData = chartData.y2[j].value;
            lineData.unshift(chartData.y2[j].key);
            options.data.columns.push(lineData);
            options.data.colors[chartData.y2[j].key] = chartData.y2[j].color || colors[j % colors.length];
            options.data.types[chartData.y2[j].key] = chartData.y2[j].type || HChart.CHART_TYPES.SPLINE;
            options.data.axes = {...options.data.axes, ...chartData.y2[j].axes};
        }

        if (chartData.color) {
            options.data.color = chartData.color;
        }

	    options.size = chartData.size || {};
	    options.pie.label.show = !chartData.hideLabel;
	    options.donut.label.show = !chartData.hideLabel;
        if (chartData.donut && chartData.donut.width ) {
            options.donut.width = chartData.donut.width ;
        }

	    options.tooltip.position = data.tooltipPosition || undefined;
	    options.tooltip.show = (chartData.tooltip && chartData.tooltip.show !== undefined ) ? chartData.tooltip.show : options.tooltip.show;
	    options.donut.expand = (chartData.donut && chartData.donut.expand !== undefined ) ? chartData.donut.expand : true;
	    options.donut.title = (chartData.donut && chartData.donut.title !== undefined ) ? chartData.donut.title : '';
	    options.tooltip.format.name = data.tooltipNameFormat || undefined;
	    options.tooltip.format.value = data.tooltipValueFormat || undefined;
	    options.tooltip.contents = data.tooltipContents || undefined;
	    options.gauge.width = data.gaugeWidth || options.gauge.width;
	    options.gauge.label.format = data.gaugeLabelFormat || options.gauge.label.format;
        if (data?.bar?.labels) {
            options.data.labels = data.bar.labels;
        }

        var types = ["bar", "gauge", "pie","donut"];
        for (const key in types) {
            var type = types[key]
            if (!data.dataType || type != data.dataType.toLowerCase()) options[types[key]] = {};
        }

        if (!isNaN(data.padding)) {
            options.padding = {
                top: data.padding,
                left: data.padding,
                bottom: data.padding,
                right: data.padding,
            };
        }

        if (data.bar && data.bar.width && !isNaN(data.bar.width.ratio)) {
            options.bar.width = (options.bar.width) ? options.bar.width : {};
            options.bar.width.ratio = data.bar.width.ratio;
        }

        if (data.bar && data.bar.width && isNaN(data.bar.width.ratio)) {
            options.bar.width= data.bar.width;
        }

        if (typeof(data.padding) == 'object') {
            options.padding = data.padding;
        }

        options.grid.x.lines = chartData.xLines || options.grid.x.lines;
        options.axis.x.tick.format = chartData.xAxisTimeFormat || options.axis.x.tick.format;

        if (chartData.axis) {
            options.axis = chartData.axis;
        }

        if (chartData.xAxisType) {
            options.axis.x.type = chartData.xAxisType;
        }

        if(chartData.yAxisValueFormat) {
            options.axis.y.tick.format = chartData.yAxisValueFormat;
        }

        if (chartData.axis) {
            options.axis = chartData.axis;
        }


        if (chartData.color) {
            options.color = chartData.color;
        }

        options.zoom.enabled = !chartData.zoomDisabled;

        if (chartData.onrendered) {
            options.onrendered = chartData.onrendered;
        }

        if (chart) {
            try{
                chart.destroy();
            }
            catch (e){

            }
        }

        chartId = id;

        element.html(
            '<div class="h-chart-box"><div id="' + chartId + '" class="h-chart"></div></div>'
        );

        options.legend.show = false;//!chartData.hideLegend;
        options.legend.position = 'right';
        options.legend.inset.step = options.data.columns.length+1;

        if (chartData.c3Legend?.show) {
            const legendsNum = chartData.y?.length || 2;
            options.legend = {
                show: true,
                position: chartData.c3Legend.position || 'inset',
                inset: chartData.c3Legend.inset || {
                    anchor: 'top-right',
                    x: 20 * legendsNum,
                    y: -15,
                    step: 1
                }
            }
        }

        options.bindto = '#' + chartId;
        chart = c3.generate(options);

        if (chartData.dataType == HChart.CHART_TYPES.BAR && options.data && options.data.columns[0] &&options.data.columns[0].length > 8) {
            //chart.zoom([0, 6])
        }

        if (chartData.donut?.tooltip?.show) {
            renderCenterTitleTooltip(chartId, chartData);
        }

        if (!chartData.showGaugeValue) {
            hideGaugeValue(chartId);
        }

        if(!chartData.c3Legend?.show && !chartData.hideLegend){
            renderLegend(chartData);
        }

        if (chartData.axis?.rotated) {
            d3.select(`#${chartId}`).classed(`rotated-chart` , true);
        }
        return chart;
    };

    const centerTooltipPosition = (element) =>{
        const rect = element.getBoundingClientRect();
        return {
            top: rect.top + window.scrollY - 30,
            left: rect.left + window.scrollX + rect.width / 2
        };
    }

    const renderCenterTitleTooltip = (chartId, chartOptions) => {
        let tooltip = d3.select("body").append("div")
            .attr("class", "h-chart-tooltip position-absolute bg-light border border-secondary rounded p-2 fs-18")

        d3.select(`#${chartId} .c3-chart-arcs-title`)
            .on("mouseover", function () {
                tooltip.style("display", "block");
            })
            .on("mousemove", function () {
                const pos = centerTooltipPosition(this);
                tooltip
                    .style("top", `${pos.top}px`)
                    .style("left", `${pos.left}px`)
                    .text(chartOptions.donut?.tooltip?.label);
            })
            .on("mouseout", function () {
                tooltip.style("display", "none");
            });
    }

    const hideGaugeValue = (chartId) => {
        d3.select(`#${chartId} .c3-gauge-value`).remove();
    };

    self.getData = function () {
        return chart.data();
    };

    self.getOptions = function(){
        return options;
    }


};


/**
 * Chart types, we can add another types from c3js.org
 */
HChart.CHART_TYPES = {
    AREA_SPLINE: 'area-spline',
    BAR: 'bar',
    SPLINE: 'spline',
    LINE: 'line',
    PIE: 'pie',
    DONUT: 'donut',
    GAUGE: 'gauge'
};

/**
 * x axis types you can use category type to make x axis as string
 */
HChart.X_AXIS_TYPES = {
    CATEGORY: 'category',
    TIME_SERIES: 'timeseries',
    INDEXED: 'indexed'
};
